// @flow

import React, { Component } from 'react';

import { translate } from '../../../base/i18n';
import { connect } from '../../../base/redux';

import { Icon, IconClose } from '../../../base/icons';
import { getLocalParticipant, PARTICIPANT_ROLE, getParticipantDisplayName } from '../../../base/participants';
import { WHITEBOARD_CLOSE_COMMAND, WHITEBOARD_OPEN_COMMAND } from '../../../whiteboard/constants';

declare var APP: Object;

const generateEncryptionKey = async () => {
    const key = await window.crypto.subtle.generateKey(
        {
            name: "AES-GCM",
            length: 128,
        },
        true, // extractable
        ["encrypt", "decrypt"],
    );
    return (await window.crypto.subtle.exportKey("jwk", key)).k;
};

/**
 * React Component for holding the chat feature in a side panel that slides in
 * and out of view.
 */
class Whiteboard extends Component<Props> {

    /**
     * Initializes a new {@code Chat} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            key: null
        }
        // Bind event handlers so they are only bound once for every instance.
        generateEncryptionKey().then(key => {
            this.setState({ key })
        })
        this._closeWhiteboard = this._closeWhiteboard.bind(this)
    }

    /**
     * Implements {@code Component#componentDidMount}.
     *
     * @inheritdoc
     */
    componentDidMount() {
    }

    /**
     * Implements {@code Component#componentDidUpdate}.
     *
     * @inheritdoc
     */
    componentDidUpdate(prevProps) {
    }

    _closeWhiteboard() {
        const { _conference, _isOpen } = this.props
        if (_isOpen) {
            _conference.sendCommandOnce(WHITEBOARD_CLOSE_COMMAND, { value: ((window.isWhiteboardByMe)?window.isWhiteboardByMe : false),tp: Date.now() });
        }
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _isOpen, _room, _displayName } = this.props;
        if (!_isOpen) { return null }
        return (<div className="white-board" style={{
            position: 'absolute',
            border: 'none',
            top: '-2px', left: '-2px', bottom: '66px', right: '0px', zIndex: '1'
        }}>
            <div className="overlay" style={{
                borderRadius: '4px',
                backgroundColor: 'hsl(0 0% 95% / 0.96)',
                boxShadow: '0 1px 5px rgba(0,0,0,0.15)',
                position: 'fixed',
                transition: 'box-shadow .5s ease-in-out',
                margin: '10px',
                cursor: "pointer"
            }} onClick={this._closeWhiteboard}>
                <div className="close-icon" style={{
                    position: 'fixed',
                    opacity: '100%',
                    backgroundColor: '#e9ecef',
                    width: '2.5rem',
                    height: '2.5rem',
                    color: '#000',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '0.25rem'
                }}>
                    <Icon src={IconClose} />
                </div>
            </div>
            <iframe src={"https://meetingwb.remotepc.com/#room=" + _room + ",I25gM8BYLoZ4lk5Qz8p07g?name=" + _displayName} style={{
                height: '100%',
                width: '100%'
            }}></iframe>
        </div>
        );
    }
}



/**
 * Maps (parts of) the redux state to {@link Chat} React {@code Component}
 * props.
 *
 * @param {Object} state - The redux store/state.
 * @private
 * @returns {{
 *     _isOpen: boolean,
 *     _messages: Array<Object>,
 *     _showNamePrompt: boolean
 * }}
 */
function _mapStateToProps(state: Object) {
    const localParticipant = getLocalParticipant(state);
    const displayName = getParticipantDisplayName(state,localParticipant.id)
    const { isOpen } = state['features/whiteboard'];
    const { meeting } = state['features/base/conference'];
    const { conference } = state['features/base/conference'];
    return {
        _isModerator: Boolean(localParticipant?.role === PARTICIPANT_ROLE.MODERATOR),
        _isOpen: isOpen,
        _room: meeting.slug,
        _displayName: displayName,
        _conference: conference
    };
}

export default translate(connect(_mapStateToProps)(Whiteboard));
